import { Paper, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import {
  SectionOf,
  TabId,
} from "../../../services/api/types/portalConfiguration/translations";
import { gray } from "../../../theme/themePrimitives";
import { TranslationTabSection } from "./components/TranslationTabSection/TranslationTabSection";
import { usePageMetadata } from "../../../context/PageMetadataContext";

interface PortalTranslationProps {}

// Ties each tab's `sections` to that tab's actual SectionOf<T> keys from the seed,
// so a renamed/removed section fails tsc here instead of silently rendering "0 texts".
function defineTab<T extends TabId>(config: {
  id: T;
  label: string;
  sections: readonly SectionOf<T>[];
}) {
  return config;
}

const TABS = [
  defineTab({
    id: "appFrame",
    label: "App Frame",
    sections: ["mainMenu", "navbar"],
  }),
  defineTab({
    id: "home",
    label: "Home",
    sections: [
      "header",
      "assignments",
      "filters",
      "banner",
      "modalLockedAssignment",
    ],
  }),
  defineTab({
    id: "login",
    label: "Login",
    sections: ["loginHeader", "loginForm", "loginMessages", "footer"],
  }),
  defineTab({
    id: "forgot-password",
    label: "Forgot Password",
    sections: [
      "forgotPasswordHeader",
      "forgotPasswordForm",
      "forgotPasswordInfo",
      "forgotPasswordMessages",
    ],
  }),
  defineTab({
    id: "new-password",
    label: "New Password",
    sections: [
      "setNewPasswordHeader",
      "setNewPasswordForm",
      "passwordReset",
      "setNewPasswordMessages",
      "activateAccountForm",
    ],
  }),
  defineTab({
    id: "link-expired",
    label: "Link Expired",
    sections: ["linkExpiredHeader", "linkExpiredForm"],
  }),
  defineTab({
    id: "assignment-detail",
    label: "Assignment Detail",
    sections: [
      "courseContentTab",
      "notesTab",
      "header",
      "acknowledgmentLocked",
      "acknowledgmentRequired",
      "acknowledgmentSubmitted",
      "acknowledgmentNotRequired",
      "acknowledgmentPageByPage",
      "modalMaxAttemptsLimit",
    ],
  }),
  defineTab({
    id: "errorPage",
    label: "Error Page",
    sections: ["messages"],
  }),
  defineTab({
    id: "certificates",
    label: "Certificates",
    sections: ["page", "certificateView"],
  }),
  defineTab({
    id: "my-profile",
    label: "My Profile",
    sections: ["page", "resetPasswordModal", "messages"],
  }),
];

export const PortalTranslation: React.FC<PortalTranslationProps> = () => {
  const [activeTab, setActiveTab] = useState(0);
  const currentTab = TABS[activeTab];

  const handleTabChange = (event: any, newValue: number) => {
    setActiveTab(newValue);
  };

  usePageMetadata({
    title: "Portal Translation",
    breadcrumbs: [
      {
        label: "Portal configuration",
        path: `/portal-configuration`,
      },
      {
        label: "Portal translation",
      },
    ],
  });

  return (
    <Paper>
      {/* <Button
        component={Link}
        to={`/portal-configuration/${portalUid}/portal-translation/find-and-replace`}
        variant="outlined"
      >
        Find & Replace
      </Button> */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        textColor="primary"
        indicatorColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          minHeight: "unset",
          borderBottom: `1px solid ${gray[200]}`,
        }}
      >
        {TABS.map((t) => (
          <Tab key={t.id} label={t.label} />
        ))}
      </Tabs>
      <TranslationTabSection
        tabSection={currentTab.id}
        tabs={currentTab.sections}
      />
    </Paper>
  );
};
